
export const StatutLivraison = {
  NON_LIVREE: "Non livrée",
  PARTIELLE: "Partielle",
  LIVREE: "Livrée",
  ANNULEE: "Annulée"
} as const;

export type StatutLivraisonType = typeof StatutLivraison[keyof typeof StatutLivraison];
